import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, FormulaireState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type FormulaireGetter = GetterTree<FormulaireState, RootState>

const state: FormulaireState = {
  formulaire: null
}

export const getters: FormulaireGetter = {
  formulaireGetter: (state) => state.formulaire
}

export const actions: ActionTree<FormulaireState, RootState> = {
  async deleteFormulaireAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/formulaire/${id}`)
    return id
  }
}

const mutations: MutationTree<FormulaireState> = {
  getFormulaireByIdMutation(state, data) {
    state.formulaire = data
  },
  resetFormulaireMutation(state) {
    state.formulaire = null
  }
}

export const formulaire: Module<FormulaireState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
